module.exports = __webpack_public_path__ + "img/t4-t1.4d42b256.svg";